import { FetchError } from './fetch-error';
export const DEFAULT_TIMEOUT = 6000;
export async function fetchWithTimeout(resource, options = {}) {
    const { timeout = DEFAULT_TIMEOUT } = options;
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);
    try {
        const response = await fetch(resource, {
            ...options,
            signal: controller.signal
        });
        clearTimeout(id);
        return response;
    }
    catch (error) {
        clearTimeout(id);
        throw new FetchError(500, 'Request failed', 'connection');
    }
}
